import React from 'react'

class Footer extends React.Component {
  render() {
    return(
      <footer>
        <ul id='contact'>
          {this.props.data.map(({ node }, index) =>
            <li key={node.name}><a href={node.link} target='_blank' className={node.name}><i className={`fa ${node.icon}`}></i></a></li>
          )}
        </ul>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js